export const convertToBoolean = (str: string): boolean | string => {
  return str === 'true' ? true : str === 'false' ? false : str
}
